export { default } from './AreaGraph';
